import React from 'react';

function parseBold(line) {
  const parts = line.split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part
  );
}

export default function TrainingTextSection({ section }) {
  const body = section?.textContent?.body || '';
  const image = section?.textContent?.image || '';

  if (!body && !image) return <div className="text-muted fst-italic">Sin contenido.</div>;

  const textBlock = body ? (
    <div className="tts-body" style={{ lineHeight: '1.7', fontSize: '1rem', textAlign: 'justify' }}>
      {body.split('\n').map((line, i, arr) => (
        <p key={i} style={{ margin: i < arr.length - 1 ? '0 0 0.5em' : 0 }}>
          {parseBold(line)}
        </p>
      ))}
    </div>
  ) : null;

  if (!image) return <div style={{ width: '100%' }}>{textBlock}</div>;

  return (
    <div style={{ display: 'flex', gap: '1.25rem', alignItems: 'flex-start', width: '100%' }}>
      {textBlock && (
        <div style={{ flex: '1 1 60%', minWidth: 0 }}>{textBlock}</div>
      )}
      <div style={{ flex: '0 0 38%', maxWidth: '38%' }}>
        <img
          src={image}
          alt=""
          style={{ width: '100%', height: 'auto', borderRadius: 8, objectFit: 'contain' }}
        />
      </div>
    </div>
  );
}
